import React from 'react';
import { HERO_MOCKUP_IMAGE } from '../../data/site';
export function HeroMockup() {
  return <figure className="mx-auto w-full max-w-[340px] sm:max-w-[480px] lg:max-w-[580px]" data-id="element-399" data-mp="q0khnlo67pp2">
      <img src={HERO_MOCKUP_IMAGE} alt="Flag Football Class Ready digital teaching pack: the main volume with its five bonus volumes shown as a boxed set" fetchPriority="high" width={1400} height={1140} className="block h-auto w-full drop-shadow-[0_24px_32px_rgba(58,14,8,0.28)]" data-id="element-400" data-mp="c8w55ha0ez7k" />
      <figcaption className="mt-3 text-center text-xs text-body sm:text-sm" data-id="element-401" data-mp="7acitfri7leo">
        Digital PDF pack · Illustrative mockup · Nothing shipped
      </figcaption>
    </figure>;
}